import {BibliographyItem} from '../types/BibliographyItem';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class BibliographyItemsService {
  public async getAllBibliographyItems(): Promise<BibliographyItem[]> {
    return handleError(
      () => httpClient.get<BibliographyItem[]>('/bibliography-items'),
      'Error fetching bibliography items:',
      () => []
    );
  }

  public async getBibliographyItem(id: string): Promise<BibliographyItem> {
    return handleError(
      () => httpClient.get<BibliographyItem>(`/bibliography-items/${id}`),
      'Error fetching bibliography item:'
    );
  }

  public async createBibliographyItem(bibliographyItem: Omit<BibliographyItem, 'id'>): Promise<void> {
    const bibliographyItemWithId = {
      ...bibliographyItem,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/bibliography-items', bibliographyItemWithId),
      'Error creating bibliography item:'
    );
  }

  public async updateBibliographyItem(bibliographyItem: BibliographyItem): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/bibliography-items/${bibliographyItem.id}`, bibliographyItem),
      'Error updating bibliography item:'
    );
  }

  public async deleteBibliographyItem(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/bibliography-items/${id}`),
      'Error deleting bibliography item:'
    );
  }

  public async importBibliographyItems(publicationId: string, csvContent: string): Promise<void> {
    return handleError(
      () => httpClient.post<void>('/bibliography-items/import', { publicationId, csvContent }),
      'Error importing bibliography items:'
    );
  }
}

const bibliographyItemsService = new BibliographyItemsService();
export default bibliographyItemsService;

